<template>
  <div class="page">
    <header-title :title="title">
      <template #left>
        <span style="padding-left: 15px">Kanban Board as customer</span>
      </template>
      <template #right>
        <a-button class="custom-t-btn" type="link" @click="printer">
          <template #icon>
            <printer-outlined />
          </template>
        </a-button>
      </template>
    </header-title>
    <div class="s-filter-box notprint">
      <a-form layout="inline" :model="search">
        <a-form-item v-if="actived !== 3">
          <a-input
            allowClear
            class="w1"
            v-model:value="search.partNum"
            placeholder="Part number"
          ></a-input>
        </a-form-item>
        <a-form-item>
          <a-select
            v-model:value="search.supplier"
            placeholder="Supplier"
            class="sel"
            allowClear
          >
            <a-select-option
              v-for="item in supplierList"
              :key="item"
              :value="item"
            >
              {{ item }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-select
            v-model:value="search.customType"
            placeholder="Customer"
            class="sel"
            allowClear
          >
            <a-select-option
              v-for="item in customerList"
              :key="item"
              :value="item"
            >
              {{ item }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-select
            v-model:value="search.status"
            placeholder="Status"
            class="sel"
            allowClear
          >
            <a-select-option
              v-for="item in statusList"
              :key="item"
              :value="item"
            >
              {{ item }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item>
          <a-space>
            <a-button type="primary" @click="find">
              <template #icon><SearchOutlined /></template>
              Find
            </a-button>
            <a-button type="primary" @click="reset">
              <template #icon><rollback-outlined /></template>
              Reset
            </a-button>
          </a-space>
        </a-form-item>
      </a-form>
    </div>
    <div class="has-filter-box kanban-content">
      <div
        v-if="pageConfig.pageIndex !== 1"
        class="previous-page button notprint"
        @click="previousPage"
      >
        <left-outlined />
      </div>
      <div
        class="next-page button notprint"
        v-if="pageConfig.pageIndex < totalPage"
        @click="nextPage"
      >
        <right-outlined />
      </div>
      <div class="side-tabs notprint">
        <div @click="setActived(1)" :class="{ current: actived === 1 }">
          FIFO
        </div>
        <div @click="setActived(2)" :class="{ current: actived === 2 }">
          2Bin
        </div>
        <div @click="setActived(3)" :class="{ current: actived === 3 }">
          Kitting cart
        </div>
      </div>
      <div class="v-content">
        <div class="in-con" v-if="dataList.length && actived !== 3">
          <div
            class="row v-row"
            v-for="(item, index) in dataList"
            :key="'row' + index"
          >
            <span class="line-num">{{ index + 1 }}</span>
            <!--start 表格-->
            <div class="t-box">
              <div class="row">
                <div class="col col-33 label">Part number</div>
                <div class="col">{{ item.partNum }}</div>
              </div>
              <div class="row">
                <div class="col col-33 label">Description</div>
                <div class="col" :title="item.description">
                  {{ item.description }}
                </div>
              </div>
              <div class="row">
                <div class="col col-33 label">Supplier</div>
                <div class="col">{{ item.supplier }}</div>
              </div>
              <div class="row">
                <div class="col col-33 label">Customer</div>
                <div class="col">{{ item.customer }}</div>
              </div>
              <div class="row">
                <div class="col col-33 label">Cards</div>
                <div class="col">{{ item.cardNum }}</div>
              </div>
            </div>
            <!--end 表格-->
            <div
              class="card"
              :class="setCardClass(i.statusType)"
              v-for="(i, idx) in item.listCardObject"
              :key="idx"
            >
              <ul class="v-list">
                <li class="top">
                  <i class="iconfont" :class="getIcon(i.statusType)"></i>
                  <p class="t" :title="i.statusType">{{ i.statusType }}</p>
                  <p class="v">{{ i.objectQty }} pcs</p>
                </li>
                <li class="n">{{ i.objectID }}</li>
                <li class="bot">
                  <p>{{ getDateType(i.statusType) }}</p>
                  <div class="d">
                    {{ dayjs(i.date).format('YYYY/MM/DD HH:mm') }}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div
          class="in-con flex-list-con"
          v-if="dataList.length && actived === 3"
        >
          <div
            class="card"
            :class="setCardClass(i.cardType)"
            v-for="(i, index) in dataList"
            :key="index"
            @click="currentItems = i"
          >
            <a-popover
              :title="currentItems.cartID + ' 物料明细'"
              trigger="click"
            >
              <template #content>
                <a-table
                  :columns="columns"
                  :row-key="(record) => record.id"
                  :data-source="currentItems.cardObject"
                  size="small"
                  :pagination="false"
                ></a-table>
              </template>
              <ul class="v-list">
                <li class="top">
                  <i class="iconfont" :class="getIcon(i.cardType)"></i>
                  <p class="t" :title="i.cardType">{{ i.cardType }}</p>
                  <p class="v">{{ i.objectQty }} pcs</p>
                </li>
                <li class="n">{{ i.cartID }}</li>
                <li class="bot">
                  <p>{{ getDateType(i.cardType) }}</p>
                  <div class="d">
                    {{ dayjs(i.date).format('YYYY/MM/DD HH:mm') }}
                  </div>
                </li>
              </ul>
            </a-popover>
          </div>
        </div>
        <div class="page-paging-box notprint" v-if="dataList.length">
          <a-pagination
            v-model:current="pageConfig.pageIndex"
            v-model:page-size="pageConfig.pageSize"
            :page-size-options="pageConfig.pageSizeList"
            :total="pageConfig.totalCount"
            show-size-changer
            @showSizeChange="onShowSizeChange"
            @change="onPageChange"
          ></a-pagination>
        </div>

        <a-empty v-else :image="simpleImage" />
      </div>
    </div>
  </div>
</template>
<script setup>
  import { reactive, ref } from 'vue'
  import HeaderTitle from '@/layout/header-title'
  import { reportURL } from '@/config'
  import request from '@/utils/request'
  import { Empty } from 'ant-design-vue'
  import dayjs from 'dayjs'
  const simpleImage = Empty.PRESENTED_IMAGE_SIMPLE
  import {
    SearchOutlined,
    RollbackOutlined,
    LeftOutlined,
    RightOutlined,
    PrinterOutlined,
  } from '@ant-design/icons-vue'
  import { message } from 'ant-design-vue'

  const search = reactive({
    card: 'FIFO',
    customType: null,
    status: null,
    supplier: null,
  })
  const columns = ref([
    {
      title: '序号',
      dataIndex: 'no',
      key: 'no',
      customRender({ index }) {
        return index + 1
      },
      width: 50,
    },
    {
      title: '物料号',
      dataIndex: 'partNum',
      width: 100,
    },
    {
      title: '物料名称',
      dataIndex: 'matName',
      width: 100,
    },
    {
      title: '数量',
      dataIndex: 'qty',
      width: 60,
    },
  ])

  const title = ref('FIFO')
  const actived = ref(1)
  const totalPage = ref(0)
  const pageConfig = reactive({
    pageSizeList: [3, 4, 5, 6, 7, 8, 9, 10, 20, 30, 50],
    pageSize: 5,
    pageIndex: 1, //当前页码
    totalCount: 10, //总记录数
  })
  const currentItems = ref({ cardObject: [] })
  const supplierList = ref([])
  const customerList = ref([])
  const statusList = ref([])
  const dataList = ref([])
  const printer = () => {
    window.print()
  }
  const onShowSizeChange = (current, pageSize) => {
    pageConfig.pageSize = pageSize
    pageConfig.pageIndex = 1
  }
  const onPageChange = () => {
    getList()
  }
  const getIcon = (type) => {
    let ret = ''
    switch (type) {
      case 'Replenish Request':
        ret = 'icon-wuliaomingxi'
        break
      case 'Vendor Stock':
        ret = 'icon-cangku'
        break
      case 'In Transit':
        ret = 'icon-wuliu'
        break
      case 'Received':
        ret = 'icon-qianshou'
        break
      default:
        ret = ''
    }
    return ret
  }
  const getDateType = (type) => {
    let ret
    switch (type) {
      case 'Replenish Request':
        ret = 'Published in'
        break
      case 'Vendor Stock':
        ret = 'Ready in'
        break
      case 'In Transit':
        ret = 'Confirmed within'
        break
      case 'Received':
        ret = 'Received on'
        break
      default:
        ret = ''
    }
    return ret
  }
  const setActived = (v) => {
    actived.value = v
    switch (v) {
      case 1:
        title.value = 'FIFO'
        document.title = 'FIFO'
        pageConfig.pageSize = 5
        break
      case 2:
        title.value = '2BIN'
        document.title = '2BIN'
        pageConfig.pageSize = 5
        break
      case 3:
        title.value = 'Kitting cart'
        document.title = 'Kitting cart'
        pageConfig.pageSize = 20
        break
      default:
        title.value = 'FIFO'
    }
    find()
  }
  const getList = (hasLoading = true) => {
    let loading
    if (hasLoading) {
      loading = message.loading('Loading……')
    }

    const { pageIndex, pageSize } = pageConfig
    let formatSearch = {}
    Object.keys(search).forEach((key) => {
      formatSearch[key] = search[key] || null
    })
    const reqData = {
      ...formatSearch,
      pageNumber: pageIndex,
      pageSize: pageSize * 1,
      card: title.value,
    }
    if (!reqData.partNum) {
      reqData.partNum = null
      search.partNum = null
    }
    request({
      method: 'post',
      url: '/api/kanban/vendorKanbanView',
      data: reqData,
      baseURL: reportURL,
    })
      .then((res) => {
        const { cards, customerName, mdVendors, status } =
          res.body.topfilterArea
        const bottomArea = res.body.bottomArea
        cards.value = cards
        supplierList.value = mdVendors
        customerList.value = customerName
        statusList.value = status
        pageConfig.totalCount = bottomArea.totalNum

        dataList.value =
          actived.value === 3
            ? bottomArea.listCardCart || []
            : bottomArea.serviceTypeAreas
        totalPage.value = Math.ceil(bottomArea.totalNum / pageSize)
      })
      .finally(() => {
        loading()
      })
  }
  const find = () => {
    pageConfig.pageIndex = 1
    getList()
  }
  const reset = () => {
    pageConfig.pageIndex = 1
    Object.keys(search).forEach((key) => {
      search[key] = null
    })
    getList()
  }
  const nextPage = () => {
    // 下一页
    if (pageConfig.pageIndex < totalPage.value) {
      pageConfig.pageIndex++
      getList()
    }
  }
  const previousPage = () => {
    // 上一页
    if (pageConfig.pageIndex > 1) {
      pageConfig.pageIndex--
      getList()
    }
  }

  const setCardClass = (state) => {
    // 去空格并转为小写
    if (state) {
      return 'color-' + state.replace(/\s+/g, '').toLocaleLowerCase()
    }
  }
  getList()
</script>

<style lang="less" scoped>
  @import './css.less';
  .w1 {
    width: 150px;
  }
</style>
